import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'usimweb-table',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: false
})
export class TableComponent implements OnChanges {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  @Input() columns: string[] = [];

  @Input() names: string[] = [];

  @Input() data: unknown[] = [];

  @Input() filter: string = '';

  @Input() deleteBtn: boolean = false;

  @Output() deleteEvent: EventEmitter<any> = new EventEmitter<any>();

  @Output() clickedRow: EventEmitter<any> = new EventEmitter<any>();

  public dataSource!: MatTableDataSource<any>;

  ngOnChanges(changes: SimpleChanges): void {
    if (this.data && changes['data']) {
      this.dataSource = new MatTableDataSource<unknown>(this.data);
      this.dataSource.paginator = this.paginator;
    }
    if (this.filter && changes['filter']) {
      this.dataSource.filter = this.filter.trim().toLowerCase();
    }
  }

  public delete(value: string) {
    this.deleteEvent.emit(value);
  }

  public clicked(row: any) {
    this.clickedRow.emit(row);
  }
}
